if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (this.cart) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitting || this.updateUnconfirmed || this.submitButton.disabled || this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.submitting = true;
        this.handleErrorMessage();
        this.submitButton.setAttribute('aria-disabled', 'true');
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner')?.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        try {
          const result = await fetch(routes.cart_add_url, config);
          const response = await result.json();
          if (!result.ok || response.status) {
            const message = response.description || response.message || window.cartStrings.addFailed;
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: response.errors || message,
              message,
            });
            if (result.status >= 500 || Number(response.status) >= 500) this.updateUnconfirmed = true;
            this.handleErrorMessage(`${message} ${window.cartStrings.addReview}`, true);
            return;
          }
          if (!this.cart) {
            window.location.assign(window.routes.cart_url);
            return;
          }

          const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
          Promise.resolve(publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-form',
            productVariantId: formData.get('id'),
            cartData: response,
          })).then(() => {
            CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
          }).catch((error) => console.error(error));

          const renderConfirmation = () => {
            CartPerformance.measure('add:paint-updated-sections', () => this.cart.renderContents(response));
          };
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => setTimeout(renderConfirmation), { once: true });
            quickAddModal.hide(true);
          } else {
            renderConfirmation();
          }
        } catch (error) {
          this.updateUnconfirmed = true;
          this.handleErrorMessage(window.cartStrings.addUnconfirmed, true);
        } finally {
          this.submitting = false;
          this.submitButton.classList.remove('loading');
          if (!this.updateUnconfirmed) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading__spinner')?.classList.add('hidden');
          CartPerformance.measureFromEvent('add:user-action', evt);
        }
      }

      handleErrorMessage(errorMessage = false, needsCartReview = false) {
        this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) {
          this.errorMessageWrapper = document.createElement('div');
          this.errorMessageWrapper.className = 'product-form__error-message-wrapper';
          this.errorMessageWrapper.setAttribute('role', 'alert');
          this.errorMessageWrapper.innerHTML = '<span class="product-form__error-message"></span>';
          this.form.prepend(this.errorMessageWrapper);
        }
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
        this.errorMessage.textContent = errorMessage || '';
        this.errorMessageWrapper.querySelector('[data-cart-error-link]')?.remove();
        if (needsCartReview) {
          const link = document.createElement('a');
          link.href = window.routes.cart_url;
          link.textContent = window.cartStrings.viewCart;
          link.dataset.cartErrorLink = '';
          link.className = 'link';
          this.errorMessageWrapper.append(' ', link);
          link.focus();
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}

